module.exports = __webpack_public_path__ + "img/responsive.585384c1.png";